import { keyframes } from "styled-components"

export const fadeIn = keyframes`
from {
    opacity: 0;
    transform: translate3d(0, -500px, 0);
}
to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
}
`
export const fadeInText = keyframes`
from {
    opacity: 0;
    transform: translate3d(-500px, 0px, 0);
}
to {
    opacity: 1;
    transform: translate3d(0px, 0px, 0);
}
`

export const slideIn = keyframes`
    from {
        transform: translateX(-2000px);
    }
    to {
        transform: translateX(0);
        visibility: visible;
    }
`
